import {
  CREATE_ACCOUNT_REQUEST,
  CREATE_ACCOUNT_SUCCESS,
  CREATE_ACCOUNT_FAILURE,
} from '../../../../Constants/actionTypes';

import { createAccountApi } from '../../../../Constants/apiService';

export const createAccountRequest = () => ({ type: CREATE_ACCOUNT_REQUEST });
export const createAccountSuccess = (data) => ({ type: CREATE_ACCOUNT_SUCCESS, payload: data });
export const createAccountFailure = (error) => ({ type: CREATE_ACCOUNT_FAILURE, payload: error });

export const createAccountAct = (payload) => {
  return async (dispatch, getState) => {
    dispatch(createAccountRequest());

    // const accessToken = getState()?.auth?.accessToken;

    try {
      const data = await createAccountApi(payload);
      dispatch(createAccountSuccess(data));
      return data;
    } catch (error) {
      const errorMessage =
        error?.message === 'Failed to fetch' || error?.message?.includes('NetworkError')
          ? 'Server is currently down. Please try again later.'
          : error?.message || 'Something went wrong';

      dispatch(createAccountFailure(errorMessage));
      throw new Error(errorMessage);
    }
  };
};
